import type React from "react";
import { useEffect } from "react";
import { getDataDomainScript } from "./OneTrustCookieBanner.utils";

export const OneTrustCookieBanner: React.FC = () => {
  const setAttributes = (
    element: HTMLElement,
    attr: { [el: string]: string }
  ) => {
    for (const key in attr) {
      if (Object.hasOwn(attr, key)) {
        element.setAttribute(key, attr[key]);
      }
    }
  };

  const loadOneTrustScript = () => {
    const scriptElement = document.createElement("script");
    scriptElement.src =
      "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
    setAttributes(scriptElement, {
      type: "text/javascript",
      id: "load-one-trust",
      "data-testid": "one-trust-src",
      "data-domain-script": getDataDomainScript()
    });

    const oneTrustScript = document.getElementById("load-one-trust");
    if (!oneTrustScript) {
      document.body.appendChild(scriptElement);
    }
  };

  const loadOneTrustContentScript = () => {
    const scriptElement = document.createElement("script") as HTMLScriptElement;
    setAttributes(scriptElement, {
      type: "text/javascript",
      id: "one-trust-content",
      "data-testid": "one-trust-content"
    });
    scriptElement.innerHTML = "function OptanonWrapper() { }";
    const oneTrustContent = document.getElementById("one-trust-content");
    if (!oneTrustContent) {
      document.body.appendChild(scriptElement);
    }
  };

  useEffect(
    () => {
      const addOneTrustScripts = () => {
        if (!process.env.NEXT_PUBLIC_DISABLE_COOKIE_CONSENT) {
          loadOneTrustScript();
          loadOneTrustContentScript();
        }
      };

      if (document.readyState === "complete") {
        addOneTrustScripts();
      } else {
        window.addEventListener("load", () => {
          addOneTrustScripts();
        });
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return null;
};
